import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDL3OUTSIDE', label: 'Three Outside Up/Down', lookback: 3 })
